import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { AuthCenteredLayout } from 'src/layouts/auth-centered';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

/** **************************************
 * Sign In
 *************************************** */
const SignIn = {
  SignInPage: lazy(() => import('src/pages/auth/sign-in')),
};

const authSignIn = {
  path: 'sign-in',
  element: (
    <GuestGuard>
      <AuthCenteredLayout>
        <SignIn.SignInPage />
      </AuthCenteredLayout>
    </GuestGuard>
  ),
};

/** **************************************
 * Register
 *************************************** */
const Register = {
  RegisterPage: lazy(() => import('src/pages/auth/register')),
};

const authRegister = {
  path: 'register',
  element: (
    <GuestGuard>
      <AuthCenteredLayout>
        <Register.RegisterPage />
      </AuthCenteredLayout>
    </GuestGuard>
  ),
};

/** **************************************
 * Reset Password
 *************************************** */
const ResetPassword = {
  ResetPasswordPage: lazy(() => import('src/pages/auth/reset-password')),
};

const authResetPassword = {
  path: 'reset-password',
  element: (
    <GuestGuard>
      <AuthCenteredLayout>
        <ResetPassword.ResetPasswordPage />
      </AuthCenteredLayout>
    </GuestGuard>
  ),
};

/** **************************************
 * Verify Email
 *************************************** */
const VerifyEmail = {
  VerifyEmailPage: lazy(() => import('src/pages/auth/verify-email')),
};

const authVerifyEmail = {
  path: 'verifyEmail/:verificationId',
  element: (
    <AuthCenteredLayout>
      <VerifyEmail.VerifyEmailPage />
    </AuthCenteredLayout>
  ),
};

/** **************************************
 * OAuth Callback
 *************************************** */
const OAuthCallback = {
  CallbackPage: lazy(() => import('src/pages/auth/oauth-callback')),
};

const authOAuthCallback = {
  path: 'callback',
  element: <OAuthCallback.CallbackPage />,
};

/** **************************************
 * Eduplaces
 *************************************** */
const Eduplaces = {
  TeacherPage: lazy(() => import('src/pages/auth/eduplaces/teacher')),
  StudentPage: lazy(() => import('src/pages/auth/eduplaces/student')),
};

const authEduplaces = {
  path: 'eduplaces',
  children: [
    {
      path: 'teacher',
      element: <Eduplaces.TeacherPage />,
    },
    {
      path: 'student',
      element: <Eduplaces.StudentPage />,
    },
  ],
};

// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      authSignIn,
      authRegister,
      authResetPassword,
      authVerifyEmail,
      authOAuthCallback,
      authEduplaces,
    ],
  },
];
